export const SOTER_IDENTITY_CONFIG = {
	authority: process.env.REACT_APP_AUTH_URI, // (string): The URL of the OIDC provider.
	client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID, // (string): Your client application's identifier as registered with the OIDC provider.
	redirect_uri: process.env.REACT_APP_REDIRECT_URI, // The URI of your client application to receive a response from the OIDC provider.
	post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
	silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URI,
	response_type: 'code', // PKCE flow
	scope: 'openid profile offline_access',
	automaticSilentRenew: true,
	loadUserInfo: true,
};

// This is the key value for site settings local storage key.
export const USER_SETTINGS_STORAGE_KEY = 'cdpUserSettings';
